export interface UserRetrieve {
    id: string
    accountId: string
    status: string
    firstName: string
    lastName: string
}

export interface UserStatus {
    key: number
    value: string
    description: string
    needRemark: boolean
    available: string[]
}

export default class User {
    static statuses(user: UserRetrieve) {
        const statuses: Array<UserStatus> = [
            {
                key: 1,
                value: 'pending_docs',
                description: 'Pending Documents',
                needRemark: false,
                available: [],
            },
            {
                key: 2,
                value: 'pending_approval',
                description: 'Pending Approval',
                needRemark: false,
                available: ['pending_docs', 'documents_need_submission'],
            },
            {
                key: 3,
                value: 'approved',
                description: 'Approved',
                needRemark: false,
                available: ['pending_approval', 'suspended', 'dormant', 'inactive'],
            },
            {
                key: 4,
                value: 'rejected',
                description: 'Rejected',
                needRemark: true,
                available: ['pending_approval'],
            },
            {
                key: 5,
                value: 'documents_need_submission',
                description: 'Documents need Submission',
                needRemark: true,
                available: ['pending_approval'],
            },
            {
                key: 6,
                value: 'pending_verification',
                description: 'Pending Verification',
                needRemark: false,
                available: [],
            },
            {
                key: 7,
                value: 'inactive',
                description: 'Inactive',
                needRemark: false,
                available: [],
            },
            {
                key: 9,
                value: 'suspended',
                description: 'Suspended',
                needRemark: true,
                available: ['approved'],
            },
            {
                key: 10,
                value: 'dormant',
                description: 'Dormant',
                needRemark: true,
                available: ['approved'],
            },
        ]

        return statuses.filter((status) => status.available.includes(user.status) || user.status === status.value)
    }
}
